/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header, NewUserModal } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import {
  useSMOrgComplianceListPageGetContent,
  useSMCreateOrgComplianceGetContent,
} from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { OrgComplianceListPageService } from '../services';
import { VApplication } from '../../../application';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.OrgComplianceListPageService'
  ) as OrgComplianceListPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();
  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const { orgComplianceListPageSend, orgComplianceListPageState } =
    useSMOrgComplianceListPageGetContent({});

  const { createOrgComplianceSend, createOrgComplianceState } =
    useSMCreateOrgComplianceGetContent({});

  const _onHeaderDDActionItemClick = (id: string) => {};
  const onCreateOrgCompliance = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const onError = () => {
    //window.location.reload(false);
    orgComplianceListPageSend('TRIGGER_REFRESH', {});
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  const onCreateSubmit = (data: any) => {
    console.log('data', data);
    if (data) {
      setShowModal(false);
      createOrgComplianceSend('MUTATE', {
        payload: data,
      });
    }
  };

  const _createOrgCompliance = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Create'}
          onSubmit={onCreateSubmit}
          onHide={() => setShowModal(false)}
          title={'Create Organization Compliance'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.createOrgCompliance?.FIELDS,
            layout: staticPageContentConfig?.createOrgCompliance?.layout,
          }}
        />
      );
    }
  };

  const onRefresh = () => {
    orgComplianceListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    orgComplianceListPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    orgComplianceListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onTogglePress = (key: string, email: string) => {
    console.log('key', key);
  };

  const _renderNotifications = () => {
    if (createOrgComplianceState?.matches('CREATE_ORG_COMPLIANCE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.createOrgCompliance ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  console.log('createOrgComplianceState', createOrgComplianceState);
  if (createOrgComplianceState?.matches('INITIATE_CREATE_ORG_COMPLIANCE')) {
    <StateOSD
      {...(staticPageContentConfig?.loading?.createOrgCompliance || {})}
    />;
  }

  const _renderPage = () => {
    if (orgComplianceListPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          {orgComplianceListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(orgComplianceListPageState?.event?.data?.value || {})}
              onTogglePress={onTogglePress}
              onViewClick={props?.onViewClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    if (orgComplianceListPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onCreateOrgCompliance}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
          {/* <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    orgComplianceListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(orgComplianceListPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={
          orgComplianceListPageState?.event?.data?.value?.ultUsers?.length
        }
      />
    );
  };

  const _renderErrorModals = () => {
    if (orgComplianceListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (createOrgComplianceState?.matches('CREATE_ORG_COMPLIANCE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.createOrgCompliance || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
      {_createOrgCompliance()}
      {_renderNotifications()}
    </div>
  );
};
